/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import Widget from './Widget';

const SHORTCUTS = [
  {
    label: 'Live Trade Chart',
    description: 'Jump straight into the trading view.',
    path: '/live-trade',
  },
  {
    label: 'Open Studio',
    description: 'Open the advanced multi-widget studio.',
    path: '/studio',
  },
  {
    label: 'Automation',
    description: 'Review systems, bots, and insights from one place.',
    path: '/ai',
  },
];

const DashboardShortcutsWidget = ({ hideTitle = false }) => {
  const navigate = useNavigate();

  return (
    <Widget title="Shortcuts" hideTitle={hideTitle} className="h-full">
      <div className="h-full flex flex-col gap-3">
        <p className="text-sm text-textSecondary">
          Launch the most-used parts of the platform without leaving the dashboard.
        </p>
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-3">
          {SHORTCUTS.map((shortcut) => (
            <button
              key={shortcut.path}
              type="button"
              onClick={() => navigate(shortcut.path)}
              className="rounded-xl border border-borderDefault bg-backgroundBody/60 p-3 text-left transition hover:bg-secondary/10"
            >
              <div className="text-sm font-medium text-textPrimary">{shortcut.label}</div>
              <div className="mt-1 text-xs text-textSecondary">{shortcut.description}</div>
            </button>
          ))}
        </div>
      </div>
    </Widget>
  );
};

export default DashboardShortcutsWidget;